import React from 'react';
import { motion } from 'framer-motion';

const CognitiveHuman = () => {
	return (
		<section className="relative min-h-screen sm:h-[750px] flex items-center justify-center overflow-hidden py-8 sm:py-12 md:py-16 lg:py-0" style={{ background: 'linear-gradient(180deg, #FFFFFF 23.08%, #D9D9D9 100%)' }}>
			{/* Top-Left Accent Arrow */}
			

			<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-12 md:py-16 lg:py-0 w-full min-h-[500px]">
			<motion.div 
							className="space-y-2 text-center lg:text-left"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, ease: "easeOut" }}
						>
							<h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-source font-semibold text-[#113861] leading-tight">
								Corporate Performance & People
							</h2>
							<h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-source italic text-[#113861] leading-tight">
								Solutions
							</h3>
						</motion.div>

				<div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-start">

					{/* Left Side - Main Content */}
                    <div className="lg:col-span-5 space-y-4 sm:space-y-6 md:space-y-8 text-center lg:text-left">
						
						{/* Right Heading */}
						<motion.h4 
							className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-sans font-regular text-[#113861] leading-tight mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ x: 30, opacity: 0 }}
							whileInView={{ x: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
						>
							Empowering workplaces with resilience and role-fit excellence
						</motion.h4>

						{/* Tree Image Container - Mobile/Tablet Layout */}
						<motion.div 
							className="lg:hidden flex justify-center mt-6 sm:mt-8 md:mt-12"
							initial={{ scale: 0.8, opacity: 0 }}
							whileInView={{ scale: 1, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 1, ease: "easeOut" }}
						>
							<img
								src="/images/glass-cube.png"
								alt="Vibrant stylized tree with colorful translucent leaves"
								className="w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 object-contain"
								style={{ 
									filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
									width: '100%',
									height: '100%'
								}}	
								 
							/>
						</motion.div>
					</div>
					

					{/* Right Side - Heading and Tree Image */}
					<div className="lg:col-span-7 space-y-4 sm:space-y-6 md:space-y-8 text-center lg:text-left">
						{/* Main Title */}
						
						{/* Descriptive Paragraph */}
						<motion.p 
							className="text-sm sm:text-base md:text-lg lg:text-xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0 mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						>
							In today's fast-paced business landscape, organisations struggle with burnout, disengagement, and mismatched roles that erode productivity. Our data-driven approach unlocks clarity at both individual and organisational levels, aligning talent with purpose and performance. By partnering with corporates, we build systems that enhance employee well-being, strengthen engagement, and cultivate high-performance cultures, and creating resilient teams and future-ready leaders.
						</motion.p>
					</div>
				</div>
			</div>

			{/* Desktop Image - Absolute Positioning (Original Layout) */}
			<motion.div 
				className="hidden lg:block absolute top-0 left-0 z-0 w-full h-full flex items-start justify-start"
				initial={{ scale: 0.8, opacity: 0 }}
				whileInView={{ scale: 1, opacity: 1 }}
				viewport={{ once: true, amount: 0.3 }}
				transition={{ duration: 1, ease: "easeOut" }}
			>
				<img
					src="/images/glass-cube.png"
					alt="Vibrant stylized tree with colorful translucent leaves"
					className="w-[50%] h-full object-contain"
					style={{ 
								filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
								width: '70%',
								height: '100%',
							position: 'absolute',
							objectFit: 'contain',
							left: '-12%',
							bottom: '-50%',
						
					}}
				/>
			</motion.div>
		</section>
	);
};

export default CognitiveHuman;